import SlotModel from './slot.model';
import { ProcessTypeEnum } from './cartDetails/process-type.enum';
import { TrafficTypeEnum } from './cartDetails/trafficType.model';
import { AddonTypeEnum } from './cartDetails/addonType.enum';
import { IAddon } from '../interfaces/cart-details.interface';

export default class SlotSecondPageModel extends SlotModel {

  public isOwner: boolean;
  public isPromotionLabelVisible: boolean;
  public isLeasingOffer: boolean;
  public discountMnpLabel: string;
  public numberTypeText: string;
  public isDataOffer: boolean;
  public hasTvAddon: boolean;
  public isRetentionOffer: boolean;

  constructor(
    bundle: any,
    ordinal: number,
    ordinalNumberInGroup: number,
  ) {
    super(bundle, ordinal, ordinalNumberInGroup);

    this.discountMnpLabel = bundle.discountMnpLabel;
    this.isPromotionLabelVisible = bundle.processType === ProcessTypeEnum.MNP && !!this.discountMnpLabel;
    this.numberTypeText = this.getNumberTypeText();
    this.isLeasingOffer = this.isLeasing();
    this.hasTvAddon = !!(this.addons.obligatory && this.addons.obligatory.find((addon: IAddon) => addon.addonType === AddonTypeEnum.TV && addon.selected));
    this.isDataOffer = this.trafficType === TrafficTypeEnum.DATA;
    this.isRetentionOffer = this.processType === ProcessTypeEnum.RETENTION;
  }

  private getNumberTypeText(): string {

    if (this.trafficType === TrafficTypeEnum.TV){
      return 'Numer do zarządzania telewizją';
    }

    switch (this.processType) {
      case ProcessTypeEnum.ACQUISITION:
      case ProcessTypeEnum.UPSELL:
        return 'Nowy numer w Play';

      case ProcessTypeEnum.MNP:
        return 'Mój numer z innej sieci';

      case ProcessTypeEnum.RETENTION:
        return 'Przedłużam umowę';

      case ProcessTypeEnum.PREPAID_2_POSTPAID: // Migration
        return 'Przechodzę z karty na abonament';

      default:
        return '';
    }
  }
}
